import { getCookie, removeCookie, setCookieAdvanced } from './cookies';

const COOKIE_NAME = 'tm_pay_confirming';
const MAX_AGE_DAYS = 30 / (24 * 60);

export function setPaymentConfirmingFlag(): void {
    setCookieAdvanced(COOKIE_NAME, '1', { days: MAX_AGE_DAYS });
}

export function clearPaymentConfirmingFlag(): void {
    removeCookie(COOKIE_NAME);
}

export function hasPaymentConfirmingFlag(): boolean {
    return !!getCookie(COOKIE_NAME);
}
